import FingerprintJS from '@fingerprintjs/fingerprintjs'
import loginByTelegram from 'api/loginByTelegram'
import { ReactNode, useCallback, useEffect, useState } from 'react'
import useLanguageForSave from 'utils/hooks/useLanguageForSave'
import useTelegramMiniapp from 'utils/hooks/useTelegramMiniapp'
import setTokensAndRedirect from 'utils/setTokensAndRedirect'

import { useTranslation } from 'next-i18next'
import Image from 'next/image'

import LanguagePicker from 'components/LanguagePicker/LanguagePicker'
import Preloader from 'components/Preloader'

import styles from './TelegramAuthLayout.module.scss'

interface TelegramAuthLayoutProps {
  children?: ReactNode
  referrer?: string
}

const TelegramAuthLayout = ({ children, referrer }: TelegramAuthLayoutProps) => {
  const [, i18n] = useTranslation(['main', 'error'])

  const savedLanguage = useLanguageForSave(i18n)
  const [isAuthLoading, setIsAuthLoading] = useState(true)

  const { getWebAppAsync } = useTelegramMiniapp()

  const tryLoginRequest = useCallback(async () => {
    try {
      const fp = await FingerprintJS.load()
      const fpResponse = await fp.get()
      const webApp = await getWebAppAsync()

      const res = await loginByTelegram({
        visitorId: fpResponse.visitorId,
        language: savedLanguage,
        initData: webApp?.initData,
      })

      if (res.data.status !== 'success') {
        setIsAuthLoading(false)
      } else {
        setTokensAndRedirect(res.data.payload.accessToken, res.data.payload.refreshToken)
      }
    } catch (error) {
      console.error(error)

      setIsAuthLoading(false)
    }
  }, [savedLanguage, getWebAppAsync])

  useEffect(() => {
    tryLoginRequest()
  }, [])

  return (
    <>
      {isAuthLoading ? (
        <Preloader />
      ) : (
        <>
          <div className={styles.header}>
            <div className={styles.logo}>
              <Image src="/images/logoWhite.svg" fill alt="Binany" priority/>
            </div>

            <div className={styles.actions}>
              <LanguagePicker referrer={referrer} position="left" />
            </div>
          </div>
          <div className={styles.content}>{children}</div>
        </>
      )}
    </>
  )
}

export default TelegramAuthLayout
